module.exports = __webpack_public_path__ + "static/img/bind_S30c.b060272.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/connect/bind_S30c.png
// module id = 749
// module chunks = 1